<template>
  <div id="ads" v-if="currentAd" class="shadow-1 bg-white"
       :style="{borderRadius: currentAd.whatsapp_url ? '0 0 10px 10px' : 0}">
    <div class="d-flex flex-align-center flex-justify-center" :key="`ad-${currentAd.id}-${externalKey}`"
         :id="`ad-${currentAd.id}-${externalKey}`" ref="adContainer">
      <circular-count-down-timer class="pos-absolute pos-top-left" :circles="timerCircles" :trigger-update="false"
                                 main-circle-id="1" :stop-conditions="{ '1': 0 }"
                                 v-if="countViewTimerId && !currentAd.viewed"></circular-count-down-timer>
      <transition name="fade">
        <div class="pos-absolute pos-bottom-left mb-1 ml-3 completed-view" v-if="completedView">
          <img src="@/assets/gifs/ad-completed.gif" alt=""
               :style="{maxWidth: `${2*maxHeight/5}px`, maxHeight: `${2*maxHeight/5}px`}">
        </div>
      </transition>
      <img :src="currentAd.imagen_url" :style="{maxWidth: '100%', maxHeight: `${maxHeight}px`}" alt=""
           :class="{'c-pointer' : trulyClickable}"
           @click="trulyClickable ? processClick() : showAdFullscreen = true" ref="adImage">
      <div class="pos-absolute pos-right-center h-100 z-2 d-flex flex-align-end">
        <div class="mb-1" v-if="currentAd.clickable && thereAreClicksLeft && !currentAd.clicked"
             :key="clickIndicatorKey">
          <img src="@/assets/gifs/click.gif" alt="" :style="{maxHeight: `${maxHeight/3}px`}">
        </div>
        <div class="h-100 px-2 fg-cobalt d-flex flex-align-center next-button c-pointer" v-if="nextAdAvailable"
             @click="nextAd()">
          <span class="ani-heartbeat"><i class="fa-solid fa-caret-right fa-3x"></i></span>
        </div>
      </div>
    </div>
    <div class="p-1 d-flex flex-justify-end" v-if="currentAd.whatsapp_url && showContacto">
      <div class="text-center fg-white text-medium px-2 c-pointer border-radius-10 d-inline-block border bd-darkGreen
                  text-secondary"
           style="background-color: #25D366" @click="open_url(currentAd.whatsapp_url)">
        <i class="fa-brands fa-whatsapp fa-lg mr-1"></i><span>Contactar al anunciante</span>
      </div>
    </div>

    <imageViewer v-if="showAdFullscreen" :url="currentAd.imagen_url" @close-image-viewer="showAdFullscreen = false">
    </imageViewer>
  </div>
</template>

<script>
import { OpenUrl } from "@/mixins/OpenUrl"
import imageViewer from "@/components/image-viewer.vue"

export default {
  name: "ads",
  data() {
    return {
      countViewTimerId: null,
      showAdFullscreen: false,
      clickIndicatorKey: Math.random().toString(36),

      timerCircles: [{
        id: '1',
        value: 2,
        size: 20,
        strokeWidth: 3,
        strokeColor: 'green',
        steps: 2,
        valueFontSize: 10
      }],

      processingNextAd: false,
      showContacto: true,

      waitingToCountView: null,
      waitingToCountClick: null,
      initializing: true,
    }
  },
  props: {
    externalKey: {
      type: [String, Number],
      default: 0
    }
  },
  mixins: [OpenUrl],
  components: {
    imageViewer
  },
  async mounted() {
    this.initializing = true
    await this.$store.dispatch('initializeAds')
    if (this.currentAd) {
      await this.newCurrentAd()
    }
    this.initializing = false
  },
  beforeDestroy () {
    clearTimeout(this.countViewTimerId)
    this.$store.dispatch('freezeAds')
  },
  methods: {
    async nextAd() {
      this.$store.commit('SET_COMPLETED_VIEW', false)
      this.$store.commit('SET_NEXT_AD_AVAILABLE', false)
      await this.$store.dispatch('nextAd')
    },
    async processClick() {
      if (this.currentAd.tipo === 'click-external') {
        let continuar = true
        if (!this.currentAd.clicked) {
          const responseModal = await this.$swal({
            text: `El anuncio lo va a llevar a un sitio externo de anunciantes de Virtual Shopping Club. VSC no se ` +
                `hace responsable del contenido de este sitio`,
            icon: 'warning',
            showCancelButton: true,
            cancelButtonText: 'Permanecer en VSC',
            confirmButtonText: 'Continuar',
          })
          continuar = responseModal.isConfirmed

          if (continuar) {
            if (typeof this.routableId === 'number') {
              this.$store.commit(
                  'ADD_CLICK',
                  {
                    routableType: this.routableType, routableId: this.routableId, shareCode: this.$route.query.shareCode
                  }
              )
            } else {
              this.waitingToCountClick = true
            }
            this.clickIndicatorKey = Math.random().toString(36)
          }
        }

        if (continuar) {
          this.open_url(this.currentAd.url)
        }
      }
    },
    initCounterViewTimer() {
      this.showContacto = true
      this.countViewTimerId = setTimeout(() => {
        this.countViewTimerId = null
        if (typeof this.routableId === 'number') {
          this.$store.commit(
              'ADD_VIEW',
              {
                routableType: this.routableType, routableId: this.routableId, shareCode: this.$route.query.shareCode
              }
          )
        } else {
          this.waitingToCountView = true
        }
      }, 2000)
    },
    async newCurrentAd() {
      if (!this.processingNextAd) {
        this.processingNextAd = true

        clearTimeout(this.countViewTimerId)
        this.countViewTimerId = null
        if (!this.currentAd.viewed) {
          setTimeout(() => {
            if (this.$refs.adImage) {
              if (this.$refs.adImage.complete) {
                this.initCounterViewTimer()
              } else {
                this.showContacto = false
                this.$refs.adImage.addEventListener('load', this.initCounterViewTimer, {once: true})
              }
            }
          }, 100)
        }

        this.processingNextAd = false
      }
    }
  },
  computed: {
    currentAd() {
      return this.$store.getters.currentAd
    },
    nextAdAvailable() {
      return this.$store.getters.nextAdAvailable
    },
    completedView() {
      return this.$store.getters.completedView
    },
    routableType() {
      switch (this.$route.name) {
        case 'desegurocompras-articulo':
          return 'ds_publicacion'
        case 'koinonia10-vista-difusion':
        case 'koinonia10-vista-difusion-publicaciones':
          return 'k10_vista_difusion'
        case 'koinonia10-publicacion':
          return 'k10_publicacion'
        default:
          return this.$route.name
      }
    },
    routableId() {
      switch (this.$route.name) {
        case 'desegurocompras-articulo':
          return Number(this.$route.params.articulo)
        case 'koinonia10-vista-difusion':
        case 'koinonia10-vista-difusion-publicaciones':
          return this.$store.getters.routableId
        case 'koinonia10-publicacion':
          return Number(this.$route.params.publicacionId)
        default:
          return 0
      }
    },
    thereAreClicksLeft() {
      return this.$store.getters.thereAreClicksLeft
    },
    trulyClickable() {
      return !!this.currentAd && this.currentAd.clickable && (this.thereAreClicksLeft || this.currentAd.clicked)
    },
    maxHeight() {
      return Math.ceil(this.$store.getters.appContentWidth * 3 / 8)
    }
  },
  watch: {
    currentAd(newValue) {
      if (newValue && !this.initializing) {
        this.newCurrentAd()
      }
    },
    routableId(newValue) {
      if (typeof newValue === 'number') {
        if (this.waitingToCountView) {
          this.$store.commit(
              'ADD_VIEW',
              {routableType: this.routableType, routableId: newValue, shareCode: this.$route.query.shareCode}
          )
          this.waitingToCountView = false
        }
        if (this.waitingToCountClick) {
          this.$store.commit(
              'ADD_CLICK',
              {routableType: this.routableType, routableId: newValue, shareCode: this.$route.query.shareCode}
          )
          this.waitingToCountClick = false
        }
      }
    },
    $route() {
      if (this.nextAdAvailable) {
        this.nextAd()
      }
    }
  }
}
</script>

<style scoped>
.next-button {
  background: #ffffff;
  background: linear-gradient(90deg,rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 1) 100%);
}
.completed-view {
  background: #48ed11;
  background: radial-gradient(circle, rgba(72, 237, 17, 1) 0%, rgba(255, 255, 255, 0) 90%);
}
</style>